import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MembershipService {
  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  createPlan(form: any): any {
    return this.http.post(`${this.url}/membershipplan/create`, form);
  }

  updatePlan(id: string, form: any): any {
    return this.http.post(`${this.url}/membershipplan/update/${id}`, form);
  }

  deletePlan(data: any): any {
    return this.http.post(`${this.url}/membershipplan/delete`, data);
  }

  getAllPlansByOrganization(filter: any): any {
    return this.http.get(`${this.url}/membershipplans/organization`, { params: filter });
  }

  getAllCustomersByOrganization(filter: any): any {
    return this.http.get(`${this.url}/membershipcustomers/organization`, { params: filter });
  }

  createCustomer(form: any): any {
    return this.http.post(`${this.url}/membershipcustomer/create`, form);
  }

  updateCustomer(id: string, form: any): any {
    return this.http.post(`${this.url}/membershipcustomer/update/${id}`, form);
  }

  cancelCustomer(form: any): any {
    return this.http.post(`${this.url}/membershipcustomer/cancel`, form);
  }

  renewCustomer(form: any): any {
    return this.http.post(`${this.url}/membershipcustomer/renew`, form);
  }

  deleteCustomer(data: any): any {
    return this.http.post(`${this.url}/membershipcustomer/delete`, data);
  }

  createPaymentIntent(form: any): any {
    return this.http.post(`${this.url}/membershipcustomer/createpaymentintent`, form);
  }

  createSubscription(form: any): any {
    return this.http.post(`${this.url}/membershipcustomer/create/subscription`, form);
  }
}